<template>
    <div class="side_icon_menu_wrap">
        <div class="side_icon_menu" @click.stop.prevent>
            <div class="side_icon_arrow pr-2">
                <v-icon color="white">mdi-chevron-left</v-icon>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "VueDataTableUtilItem",
    data() {
        return {
        }
    },
}
</script>

<style scoped>
.side_icon_menu_wrap {
    min-width: 30px;
    padding: 0;
    position: relative;
    height: 100%;
    width: 100%;
}


.side_icon_arrow {
    height: 100%;
    min-width: 20px;
    max-width: 20px;
    background-color: #F6B962;
    display: flex;
    justify-content: center;
    align-items: center;
}

.side_icon_menu__container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}

.side_icon_menu {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    position: absolute;
    padding-right: 8px;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    margin: 0;
    background-color: #F6B962;
    z-index: 1;
    transition: all 0.5s ease;
}

.side_icon_menu {
    max-width: 20px;
    overflow: hidden;
}

.side_icon_arrow:hover ~ .side_icon_menu,
.side_icon_menu:hover {
    max-width: 600px;
}

.side_icon_arrow .v-icon {
    margin-left: 6px;
}
</style>